<app-navbar>
    <h2>Joburi Favorite</h2>
</app-navbar>

<section class="job-area job-area-two pt-100" >
    <div class="container">
        <div class="row" *ngIf="jobsArray.length > 0; else noJobs">
            <div class="col-12 mb-5" *ngFor="let job of jobsArray">
                <div class="bg-white p-10">
                    <div class="row align-items-center">
                        <div class="col-md-1 col-12 text-center">
                            <img src="{{job['photoPath']}}" class="img-fluid" alt="Job">
                        </div>
                        <div class="col-md-5 text-md-left col-12 text-center">
                            <a routerLink="/job/{{job['id']}}" class="title-link mb-2 d-block">{{job["jobTitle"]}}</a>
                            <ul class="list-unstyled">
                                <li class="d-inline-block mr-2 blue-color">
                                    <i class="icofont-location-pin green-color mr-2"></i>{{job["country"]}} - {{job["city"]}}
                                </li>
                                <li class="d-inline-block mr-2 blue-color" *ngIf="job['salary']">
                                    <i class="icofont-money-bag green-color mr-2"></i>{{job["salary"]}}
                                </li>
                            </ul>
                            <ul class="list-unstyled">
                                <li class="d-inline-block mr-2 blue-color" *ngIf="job['workType']">
                                    <i class="icofont-worker green-color mr-2"></i>{{job["workType"] | enumTransform}}
                                </li>
                                <li class="d-inline-block mr-2 blue-color" *ngIf="job['openPositions']">
                                    <i class="icofont-workers-group green-color mr-2"></i>{{job["openPositions"]}}
                                </li>
                            </ul>
                            <ul class="list-unstyled">
                                <li class="d-inline-block mr-2 blue-color">
                                    <i class="icofont-calendar green-color mr-2"></i>Data Postare {{job["jobPostingDate"] | date:"dd-MM-yyyy"}}
                                </li>
                            </ul>
                        </div>

                        <div class="col-md-6 col-12">
                            <ul class="list-unstyled m-0 text-md-right text-center">
                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                    <a routerLink="/job/{{job['id']}}">
                                        <button class="c-btn details-button">Vezi Job</button>
                                    </a>
                                </li>
                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                    <button class="c-btn delete-button" (click)="modal.show()">Sterge</button>
                                </li>
                            </ul>
                        </div>

                        <!--Modal Component-->
                        <app-modal #modal>
                            <div class="app-modal-header">
                                <h5 class="custom-section-title">{{job["jobTitle"]}}</h5>
                            </div>
                            <div class="app-modal-body">
                                <span class="red-message">Esti sigur ca vrei sa stergi jobul din lista de joburi favorite?</span>
                            </div>
                            <div class="app-modal-footer">
                                <button type="button" class="btn cancel-button mr-2" (click)="modal.hide()">
                                    Renunta
                                </button>
                                <button class="btn delete-button" (click)="deleteFavJob(job['id']); modal.hide()">Sterge
                                </button>
                            </div>
                        </app-modal>

                    </div>
                </div>
            </div>
        </div>
        <ng-template #noJobs>
            <div class="no-job-found">
            <p>Nu ati adaugat niciun job in lista de favorite...</p>
            <button routerLink="/joburi" class="c-btn details-button">Vezi Joburi</button>
            </div>
        </ng-template>
    </div>
</section>

<app-footer></app-footer>
